import { DefineEntity, Entity2D, EntityType, Vector2 } from '../../../odie';
import { GameScene } from '../../GameScene';
import { BlockComponent } from '../../components/BlockComponent';
import { PositionComponent } from '../../components/PositionComponent';
import { BlockProps } from '../../defs/block';
import { BlockDef } from '../../defs/map';
import { _spawnBaseBlockEntity } from '../../entities/BlockEntity';
import { OctopusBlockComponent } from './OctopusBlockComponent';
import { OctopusBlockProps } from './OctopusBlock';

const OctopusBlockEntityDef = DefineEntity(
  Entity2D,
  PositionComponent,
  BlockComponent,
  OctopusBlockComponent,
);
export type OctopusBlockEntity = EntityType<typeof OctopusBlockEntityDef>;

export function _spawnOctopusBlockEntity(
  scene: GameScene,
  def: BlockDef,
  props: OctopusBlockProps,
  position: Vector2,
): OctopusBlockEntity {
  const entity = _spawnBaseBlockEntity(
    OctopusBlockEntityDef,
    scene,
    def.id,
    props,
    position,
    {
      blockOctopus: {
        props: props,
        option: def.option,
      },
    },
  );
  entity.c.view2d.view.addChild(entity.c.blockOctopus.view);
  return entity;
}
